import { render, staticRenderFns } from "./ord.vue?vue&type=template&id=0ed95e1c&scoped=true&"
import script from "./ord.vue?vue&type=script&lang=js&"
export * from "./ord.vue?vue&type=script&lang=js&"
import style0 from "./ord.vue?vue&type=style&index=0&id=0ed95e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed95e1c",
  null
  
)

export default component.exports